import React, { useMemo, useState } from "react";
import { notifySubmissionByEmail, saveFormSubmission } from "../utils/formSubmissions";
import "./ContactForm.css"
export default function ContactForm({ config }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [ok, setOk] = useState("");
  const [err, setErr] = useState("");

  const emailTo = useMemo(() => (config?.emails?.[0] ? String(config.emails[0]) : ""), [config]);
  const accessKey = useMemo(
    () => String(config?.accessKey || "").trim(),
    [config?.accessKey]
  );
  const fallbackNotificationEmail = useMemo(
    () => String(config?.notificationEmail || "").trim(),
    [config?.notificationEmail]
  );

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const validate = () => {
    const errors = [];
    if (!form.name.trim()) errors.push("Name is required.");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) errors.push("Valid email is required.");
    const digits = form.phone.replace(/[^\d+]/g, "");
    if (digits.replace("+", "").length < 10) errors.push("Phone number looks too short.");
    if (!form.message.trim()) errors.push("Message is required.");
    return errors;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setOk(""); setErr("");
    const problems = validate();
    if (problems.length) return setErr(problems.join(" "));

    try {
      setSubmitting(true);
      await saveFormSubmission({
        formId: config?.formId || "contact_form",
        formName: config?.formName || "Contact Form",
        formType: "contact_form",
        fields: {
          name: form.name.trim(),
          email: form.email.trim(),
          phone: form.phone.trim(),
          message: form.message.trim(),
        },
        metadata: {
          toEmail: emailTo || null,
          source: "website",
        },
      });

      let warning = "";
      try {
        await notifySubmissionByEmail({
          accessKey,
          toEmail: fallbackNotificationEmail || emailTo,
          formName: config?.formName || "Contact Form",
          fields: {
            name: form.name.trim(),
            email: form.email.trim(),
            phone: form.phone.trim(),
            message: form.message.trim(),
          },
          metadata: {
            formType: "contact_form",
          },
        });
      } catch (notifyError) {
        console.error("Contact form email notification failed", notifyError);
        warning = " We saved your request, but email notification failed.";
      }

      setOk(`Thanks! Your message has been sent.${warning}`);
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (e2) {
      console.error(e2);
      setErr(e2?.message || "Failed to send. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-card">
      <h2 className="gt-title">Enquiry Form</h2>
      <p className="gt-sub">
        We’d love to hear from you! Fill out the form and our team will get back to you as soon as possible.
      </p>

      {ok && <p className="note success">{ok}</p>}
      {err && <p className="note error">{err}</p>}

      <form onSubmit={onSubmit} className="contact-form">
        <div className="row">
          <label>Name</label>
          <input name="name" value={form.name} onChange={onChange} placeholder="Your full name" autoComplete="name" />
        </div>

        <div className="row">
          <label>Email</label>
          <input name="email" type="email" value={form.email} onChange={onChange} placeholder="you@example.com" autoComplete="email" />
        </div>

        <div className="row">
          <label>Phone Number</label>
          <input name="phone" value={form.phone} onChange={onChange} placeholder="+91 87977 74356" autoComplete="tel" />
        </div>

        <div className="row">
          <label>Message</label>
          <textarea name="message" rows={4} value={form.message} onChange={onChange} placeholder="Tell us about your project…" />
        </div>

        <button className="btn primary" type="submit" disabled={submitting}>
          {submitting ? "Sending…" : "Submit Form"}
        </button>
      </form>
    </div>
  );
}
